import { Stage } from "@pixi/react";
// import { RoySprite } from "./RoySprite";
// import useTamagotchi from "../app/StateContext";

export const PixiApp = ({children}) => {
    // const { spriteState } = useTamagotchi();

    const width = 200;
    const height = 240;
    const stageProps = {
        height,
        width,
        options: {
            backgroundAlpha: 0
        }
    };

    // if (spriteState === "away") {
    //     return (
    //         <div id="game_container" className="sprite">
    //             <Stage {...stageProps} />
    //         </div>
    //     )
    // } else {
        return (
            <div id="game_container" className="sprite">
                <Stage {...stageProps}>
                    {/* <RoySprite key={spriteState} state={spriteState}/> */}
                    {children}
                </Stage>
            </div>
        )
    // }
}